export default["Premium MasterSpec","Premium","Premium Proprietary","Manufacturer"];
